module.exports = __webpack_public_path__ + "static/img/01_arrive.ec50cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01_arrive.jpg
// module id = xUum
// module chunks = 0